// source: witbooking/backoffice/orchestrator/scenario/v1/scenario_api.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var validate_validate_pb = require('../../../../../validate/validate_pb.js');
goog.object.extend(proto, validate_validate_pb);
var witbooking_backoffice_orchestrator_globalactions_v1_global_actions_api_pb = require('../../../../../witbooking/backoffice/orchestrator/globalactions/v1/global_actions_api_pb.js');
goog.object.extend(proto, witbooking_backoffice_orchestrator_globalactions_v1_global_actions_api_pb);
var witbooking_backoffice_orchestrator_common_v1_orchestration_criteria_pb = require('../../../../../witbooking/backoffice/orchestrator/common/v1/orchestration_criteria_pb.js');
goog.object.extend(proto, witbooking_backoffice_orchestrator_common_v1_orchestration_criteria_pb);
goog.exportSymbol('proto.witbooking.backoffice.orchestrator.scenario.v1.CreateScenarioRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.orchestrator.scenario.v1.CreateScenarioResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.orchestrator.scenario.v1.DeleteScenarioRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.orchestrator.scenario.v1.DeleteScenarioResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.orchestrator.scenario.v1.GetAllScenariosRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.orchestrator.scenario.v1.GetAllScenariosResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.orchestrator.scenario.v1.GetScenarioRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.orchestrator.scenario.v1.GetScenarioResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.orchestrator.scenario.v1.ReorderScenarioRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.orchestrator.scenario.v1.ReorderScenarioResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.orchestrator.scenario.v1.Scenario', null, global);
goog.exportSymbol('proto.witbooking.backoffice.orchestrator.scenario.v1.UpdateScenarioRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.orchestrator.scenario.v1.UpdateScenarioResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.GetScenarioRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.orchestrator.scenario.v1.GetScenarioRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.orchestrator.scenario.v1.GetScenarioRequest.displayName = 'proto.witbooking.backoffice.orchestrator.scenario.v1.GetScenarioRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.GetScenarioResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.orchestrator.scenario.v1.GetScenarioResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.orchestrator.scenario.v1.GetScenarioResponse.displayName = 'proto.witbooking.backoffice.orchestrator.scenario.v1.GetScenarioResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.GetAllScenariosRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.orchestrator.scenario.v1.GetAllScenariosRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.orchestrator.scenario.v1.GetAllScenariosRequest.displayName = 'proto.witbooking.backoffice.orchestrator.scenario.v1.GetAllScenariosRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.GetAllScenariosResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.orchestrator.scenario.v1.GetAllScenariosResponse.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.orchestrator.scenario.v1.GetAllScenariosResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.orchestrator.scenario.v1.GetAllScenariosResponse.displayName = 'proto.witbooking.backoffice.orchestrator.scenario.v1.GetAllScenariosResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.CreateScenarioRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.orchestrator.scenario.v1.CreateScenarioRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.orchestrator.scenario.v1.CreateScenarioRequest.displayName = 'proto.witbooking.backoffice.orchestrator.scenario.v1.CreateScenarioRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.CreateScenarioResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.orchestrator.scenario.v1.CreateScenarioResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.orchestrator.scenario.v1.CreateScenarioResponse.displayName = 'proto.witbooking.backoffice.orchestrator.scenario.v1.CreateScenarioResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.UpdateScenarioRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.orchestrator.scenario.v1.UpdateScenarioRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.orchestrator.scenario.v1.UpdateScenarioRequest.displayName = 'proto.witbooking.backoffice.orchestrator.scenario.v1.UpdateScenarioRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.UpdateScenarioResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.orchestrator.scenario.v1.UpdateScenarioResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.orchestrator.scenario.v1.UpdateScenarioResponse.displayName = 'proto.witbooking.backoffice.orchestrator.scenario.v1.UpdateScenarioResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.DeleteScenarioRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.orchestrator.scenario.v1.DeleteScenarioRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.orchestrator.scenario.v1.DeleteScenarioRequest.displayName = 'proto.witbooking.backoffice.orchestrator.scenario.v1.DeleteScenarioRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.DeleteScenarioResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.orchestrator.scenario.v1.DeleteScenarioResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.orchestrator.scenario.v1.DeleteScenarioResponse.displayName = 'proto.witbooking.backoffice.orchestrator.scenario.v1.DeleteScenarioResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.ReorderScenarioRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.orchestrator.scenario.v1.ReorderScenarioRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.orchestrator.scenario.v1.ReorderScenarioRequest.displayName = 'proto.witbooking.backoffice.orchestrator.scenario.v1.ReorderScenarioRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.ReorderScenarioResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.orchestrator.scenario.v1.ReorderScenarioResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.orchestrator.scenario.v1.ReorderScenarioResponse.displayName = 'proto.witbooking.backoffice.orchestrator.scenario.v1.ReorderScenarioResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.Scenario = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.orchestrator.scenario.v1.Scenario, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.orchestrator.scenario.v1.Scenario.displayName = 'proto.witbooking.backoffice.orchestrator.scenario.v1.Scenario';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.GetScenarioRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.orchestrator.scenario.v1.GetScenarioRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.orchestrator.scenario.v1.GetScenarioRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.GetScenarioRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    propertyTicker: jspb.Message.getFieldWithDefault(msg, 1, ""),
    id: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.orchestrator.scenario.v1.GetScenarioRequest}
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.GetScenarioRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.orchestrator.scenario.v1.GetScenarioRequest;
  return proto.witbooking.backoffice.orchestrator.scenario.v1.GetScenarioRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.orchestrator.scenario.v1.GetScenarioRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.orchestrator.scenario.v1.GetScenarioRequest}
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.GetScenarioRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPropertyTicker(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.GetScenarioRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.orchestrator.scenario.v1.GetScenarioRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.orchestrator.scenario.v1.GetScenarioRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.GetScenarioRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPropertyTicker();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string property_ticker = 1;
 * @return {string}
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.GetScenarioRequest.prototype.getPropertyTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.orchestrator.scenario.v1.GetScenarioRequest} returns this
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.GetScenarioRequest.prototype.setPropertyTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string id = 2;
 * @return {string}
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.GetScenarioRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.orchestrator.scenario.v1.GetScenarioRequest} returns this
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.GetScenarioRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.GetScenarioResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.orchestrator.scenario.v1.GetScenarioResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.orchestrator.scenario.v1.GetScenarioResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.GetScenarioResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    scenario: (f = msg.getScenario()) && proto.witbooking.backoffice.orchestrator.scenario.v1.Scenario.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.orchestrator.scenario.v1.GetScenarioResponse}
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.GetScenarioResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.orchestrator.scenario.v1.GetScenarioResponse;
  return proto.witbooking.backoffice.orchestrator.scenario.v1.GetScenarioResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.orchestrator.scenario.v1.GetScenarioResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.orchestrator.scenario.v1.GetScenarioResponse}
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.GetScenarioResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.orchestrator.scenario.v1.Scenario;
      reader.readMessage(value,proto.witbooking.backoffice.orchestrator.scenario.v1.Scenario.deserializeBinaryFromReader);
      msg.setScenario(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.GetScenarioResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.orchestrator.scenario.v1.GetScenarioResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.orchestrator.scenario.v1.GetScenarioResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.GetScenarioResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getScenario();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.orchestrator.scenario.v1.Scenario.serializeBinaryToWriter
    );
  }
};


/**
 * optional Scenario scenario = 1;
 * @return {?proto.witbooking.backoffice.orchestrator.scenario.v1.Scenario}
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.GetScenarioResponse.prototype.getScenario = function() {
  return /** @type{?proto.witbooking.backoffice.orchestrator.scenario.v1.Scenario} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.orchestrator.scenario.v1.Scenario, 1));
};


/**
 * @param {?proto.witbooking.backoffice.orchestrator.scenario.v1.Scenario|undefined} value
 * @return {!proto.witbooking.backoffice.orchestrator.scenario.v1.GetScenarioResponse} returns this
*/
proto.witbooking.backoffice.orchestrator.scenario.v1.GetScenarioResponse.prototype.setScenario = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.orchestrator.scenario.v1.GetScenarioResponse} returns this
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.GetScenarioResponse.prototype.clearScenario = function() {
  return this.setScenario(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.GetScenarioResponse.prototype.hasScenario = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.GetAllScenariosRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.orchestrator.scenario.v1.GetAllScenariosRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.orchestrator.scenario.v1.GetAllScenariosRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.GetAllScenariosRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    propertyTicker: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.orchestrator.scenario.v1.GetAllScenariosRequest}
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.GetAllScenariosRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.orchestrator.scenario.v1.GetAllScenariosRequest;
  return proto.witbooking.backoffice.orchestrator.scenario.v1.GetAllScenariosRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.orchestrator.scenario.v1.GetAllScenariosRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.orchestrator.scenario.v1.GetAllScenariosRequest}
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.GetAllScenariosRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPropertyTicker(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.GetAllScenariosRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.orchestrator.scenario.v1.GetAllScenariosRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.orchestrator.scenario.v1.GetAllScenariosRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.GetAllScenariosRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPropertyTicker();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string property_ticker = 1;
 * @return {string}
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.GetAllScenariosRequest.prototype.getPropertyTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.orchestrator.scenario.v1.GetAllScenariosRequest} returns this
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.GetAllScenariosRequest.prototype.setPropertyTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.GetAllScenariosResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.GetAllScenariosResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.orchestrator.scenario.v1.GetAllScenariosResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.orchestrator.scenario.v1.GetAllScenariosResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.GetAllScenariosResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    scenariosList: jspb.Message.toObjectList(msg.getScenariosList(),
    proto.witbooking.backoffice.orchestrator.scenario.v1.Scenario.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.orchestrator.scenario.v1.GetAllScenariosResponse}
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.GetAllScenariosResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.orchestrator.scenario.v1.GetAllScenariosResponse;
  return proto.witbooking.backoffice.orchestrator.scenario.v1.GetAllScenariosResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.orchestrator.scenario.v1.GetAllScenariosResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.orchestrator.scenario.v1.GetAllScenariosResponse}
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.GetAllScenariosResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.orchestrator.scenario.v1.Scenario;
      reader.readMessage(value,proto.witbooking.backoffice.orchestrator.scenario.v1.Scenario.deserializeBinaryFromReader);
      msg.addScenarios(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.GetAllScenariosResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.orchestrator.scenario.v1.GetAllScenariosResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.orchestrator.scenario.v1.GetAllScenariosResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.GetAllScenariosResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getScenariosList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.witbooking.backoffice.orchestrator.scenario.v1.Scenario.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Scenario scenarios = 1;
 * @return {!Array<!proto.witbooking.backoffice.orchestrator.scenario.v1.Scenario>}
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.GetAllScenariosResponse.prototype.getScenariosList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.orchestrator.scenario.v1.Scenario>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.orchestrator.scenario.v1.Scenario, 1));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.orchestrator.scenario.v1.Scenario>} value
 * @return {!proto.witbooking.backoffice.orchestrator.scenario.v1.GetAllScenariosResponse} returns this
*/
proto.witbooking.backoffice.orchestrator.scenario.v1.GetAllScenariosResponse.prototype.setScenariosList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.witbooking.backoffice.orchestrator.scenario.v1.Scenario=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.orchestrator.scenario.v1.Scenario}
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.GetAllScenariosResponse.prototype.addScenarios = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.witbooking.backoffice.orchestrator.scenario.v1.Scenario, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.orchestrator.scenario.v1.GetAllScenariosResponse} returns this
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.GetAllScenariosResponse.prototype.clearScenariosList = function() {
  return this.setScenariosList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.CreateScenarioRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.orchestrator.scenario.v1.CreateScenarioRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.orchestrator.scenario.v1.CreateScenarioRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.CreateScenarioRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    propertyTicker: jspb.Message.getFieldWithDefault(msg, 1, ""),
    scenario: (f = msg.getScenario()) && proto.witbooking.backoffice.orchestrator.scenario.v1.Scenario.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.orchestrator.scenario.v1.CreateScenarioRequest}
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.CreateScenarioRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.orchestrator.scenario.v1.CreateScenarioRequest;
  return proto.witbooking.backoffice.orchestrator.scenario.v1.CreateScenarioRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.orchestrator.scenario.v1.CreateScenarioRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.orchestrator.scenario.v1.CreateScenarioRequest}
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.CreateScenarioRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPropertyTicker(value);
      break;
    case 2:
      var value = new proto.witbooking.backoffice.orchestrator.scenario.v1.Scenario;
      reader.readMessage(value,proto.witbooking.backoffice.orchestrator.scenario.v1.Scenario.deserializeBinaryFromReader);
      msg.setScenario(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.CreateScenarioRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.orchestrator.scenario.v1.CreateScenarioRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.orchestrator.scenario.v1.CreateScenarioRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.CreateScenarioRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPropertyTicker();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getScenario();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.witbooking.backoffice.orchestrator.scenario.v1.Scenario.serializeBinaryToWriter
    );
  }
};


/**
 * optional string property_ticker = 1;
 * @return {string}
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.CreateScenarioRequest.prototype.getPropertyTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.orchestrator.scenario.v1.CreateScenarioRequest} returns this
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.CreateScenarioRequest.prototype.setPropertyTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Scenario scenario = 2;
 * @return {?proto.witbooking.backoffice.orchestrator.scenario.v1.Scenario}
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.CreateScenarioRequest.prototype.getScenario = function() {
  return /** @type{?proto.witbooking.backoffice.orchestrator.scenario.v1.Scenario} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.orchestrator.scenario.v1.Scenario, 2));
};


/**
 * @param {?proto.witbooking.backoffice.orchestrator.scenario.v1.Scenario|undefined} value
 * @return {!proto.witbooking.backoffice.orchestrator.scenario.v1.CreateScenarioRequest} returns this
*/
proto.witbooking.backoffice.orchestrator.scenario.v1.CreateScenarioRequest.prototype.setScenario = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.orchestrator.scenario.v1.CreateScenarioRequest} returns this
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.CreateScenarioRequest.prototype.clearScenario = function() {
  return this.setScenario(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.CreateScenarioRequest.prototype.hasScenario = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.CreateScenarioResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.orchestrator.scenario.v1.CreateScenarioResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.orchestrator.scenario.v1.CreateScenarioResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.CreateScenarioResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    scenario: (f = msg.getScenario()) && proto.witbooking.backoffice.orchestrator.scenario.v1.Scenario.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.orchestrator.scenario.v1.CreateScenarioResponse}
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.CreateScenarioResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.orchestrator.scenario.v1.CreateScenarioResponse;
  return proto.witbooking.backoffice.orchestrator.scenario.v1.CreateScenarioResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.orchestrator.scenario.v1.CreateScenarioResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.orchestrator.scenario.v1.CreateScenarioResponse}
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.CreateScenarioResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.orchestrator.scenario.v1.Scenario;
      reader.readMessage(value,proto.witbooking.backoffice.orchestrator.scenario.v1.Scenario.deserializeBinaryFromReader);
      msg.setScenario(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.CreateScenarioResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.orchestrator.scenario.v1.CreateScenarioResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.orchestrator.scenario.v1.CreateScenarioResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.CreateScenarioResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getScenario();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.orchestrator.scenario.v1.Scenario.serializeBinaryToWriter
    );
  }
};


/**
 * optional Scenario scenario = 1;
 * @return {?proto.witbooking.backoffice.orchestrator.scenario.v1.Scenario}
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.CreateScenarioResponse.prototype.getScenario = function() {
  return /** @type{?proto.witbooking.backoffice.orchestrator.scenario.v1.Scenario} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.orchestrator.scenario.v1.Scenario, 1));
};


/**
 * @param {?proto.witbooking.backoffice.orchestrator.scenario.v1.Scenario|undefined} value
 * @return {!proto.witbooking.backoffice.orchestrator.scenario.v1.CreateScenarioResponse} returns this
*/
proto.witbooking.backoffice.orchestrator.scenario.v1.CreateScenarioResponse.prototype.setScenario = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.orchestrator.scenario.v1.CreateScenarioResponse} returns this
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.CreateScenarioResponse.prototype.clearScenario = function() {
  return this.setScenario(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.CreateScenarioResponse.prototype.hasScenario = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.UpdateScenarioRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.orchestrator.scenario.v1.UpdateScenarioRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.orchestrator.scenario.v1.UpdateScenarioRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.UpdateScenarioRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    propertyTicker: jspb.Message.getFieldWithDefault(msg, 1, ""),
    scenario: (f = msg.getScenario()) && proto.witbooking.backoffice.orchestrator.scenario.v1.Scenario.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.orchestrator.scenario.v1.UpdateScenarioRequest}
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.UpdateScenarioRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.orchestrator.scenario.v1.UpdateScenarioRequest;
  return proto.witbooking.backoffice.orchestrator.scenario.v1.UpdateScenarioRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.orchestrator.scenario.v1.UpdateScenarioRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.orchestrator.scenario.v1.UpdateScenarioRequest}
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.UpdateScenarioRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPropertyTicker(value);
      break;
    case 2:
      var value = new proto.witbooking.backoffice.orchestrator.scenario.v1.Scenario;
      reader.readMessage(value,proto.witbooking.backoffice.orchestrator.scenario.v1.Scenario.deserializeBinaryFromReader);
      msg.setScenario(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.UpdateScenarioRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.orchestrator.scenario.v1.UpdateScenarioRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.orchestrator.scenario.v1.UpdateScenarioRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.UpdateScenarioRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPropertyTicker();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getScenario();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.witbooking.backoffice.orchestrator.scenario.v1.Scenario.serializeBinaryToWriter
    );
  }
};


/**
 * optional string property_ticker = 1;
 * @return {string}
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.UpdateScenarioRequest.prototype.getPropertyTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.orchestrator.scenario.v1.UpdateScenarioRequest} returns this
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.UpdateScenarioRequest.prototype.setPropertyTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Scenario scenario = 2;
 * @return {?proto.witbooking.backoffice.orchestrator.scenario.v1.Scenario}
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.UpdateScenarioRequest.prototype.getScenario = function() {
  return /** @type{?proto.witbooking.backoffice.orchestrator.scenario.v1.Scenario} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.orchestrator.scenario.v1.Scenario, 2));
};


/**
 * @param {?proto.witbooking.backoffice.orchestrator.scenario.v1.Scenario|undefined} value
 * @return {!proto.witbooking.backoffice.orchestrator.scenario.v1.UpdateScenarioRequest} returns this
*/
proto.witbooking.backoffice.orchestrator.scenario.v1.UpdateScenarioRequest.prototype.setScenario = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.orchestrator.scenario.v1.UpdateScenarioRequest} returns this
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.UpdateScenarioRequest.prototype.clearScenario = function() {
  return this.setScenario(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.UpdateScenarioRequest.prototype.hasScenario = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.UpdateScenarioResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.orchestrator.scenario.v1.UpdateScenarioResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.orchestrator.scenario.v1.UpdateScenarioResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.UpdateScenarioResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.orchestrator.scenario.v1.UpdateScenarioResponse}
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.UpdateScenarioResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.orchestrator.scenario.v1.UpdateScenarioResponse;
  return proto.witbooking.backoffice.orchestrator.scenario.v1.UpdateScenarioResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.orchestrator.scenario.v1.UpdateScenarioResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.orchestrator.scenario.v1.UpdateScenarioResponse}
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.UpdateScenarioResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.UpdateScenarioResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.orchestrator.scenario.v1.UpdateScenarioResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.orchestrator.scenario.v1.UpdateScenarioResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.UpdateScenarioResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.DeleteScenarioRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.orchestrator.scenario.v1.DeleteScenarioRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.orchestrator.scenario.v1.DeleteScenarioRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.DeleteScenarioRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    propertyTicker: jspb.Message.getFieldWithDefault(msg, 1, ""),
    id: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.orchestrator.scenario.v1.DeleteScenarioRequest}
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.DeleteScenarioRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.orchestrator.scenario.v1.DeleteScenarioRequest;
  return proto.witbooking.backoffice.orchestrator.scenario.v1.DeleteScenarioRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.orchestrator.scenario.v1.DeleteScenarioRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.orchestrator.scenario.v1.DeleteScenarioRequest}
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.DeleteScenarioRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPropertyTicker(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.DeleteScenarioRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.orchestrator.scenario.v1.DeleteScenarioRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.orchestrator.scenario.v1.DeleteScenarioRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.DeleteScenarioRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPropertyTicker();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string property_ticker = 1;
 * @return {string}
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.DeleteScenarioRequest.prototype.getPropertyTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.orchestrator.scenario.v1.DeleteScenarioRequest} returns this
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.DeleteScenarioRequest.prototype.setPropertyTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string id = 2;
 * @return {string}
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.DeleteScenarioRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.orchestrator.scenario.v1.DeleteScenarioRequest} returns this
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.DeleteScenarioRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.DeleteScenarioResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.orchestrator.scenario.v1.DeleteScenarioResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.orchestrator.scenario.v1.DeleteScenarioResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.DeleteScenarioResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.orchestrator.scenario.v1.DeleteScenarioResponse}
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.DeleteScenarioResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.orchestrator.scenario.v1.DeleteScenarioResponse;
  return proto.witbooking.backoffice.orchestrator.scenario.v1.DeleteScenarioResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.orchestrator.scenario.v1.DeleteScenarioResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.orchestrator.scenario.v1.DeleteScenarioResponse}
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.DeleteScenarioResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.DeleteScenarioResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.orchestrator.scenario.v1.DeleteScenarioResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.orchestrator.scenario.v1.DeleteScenarioResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.DeleteScenarioResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.ReorderScenarioRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.orchestrator.scenario.v1.ReorderScenarioRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.orchestrator.scenario.v1.ReorderScenarioRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.ReorderScenarioRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    propertyTicker: jspb.Message.getFieldWithDefault(msg, 1, ""),
    id: jspb.Message.getFieldWithDefault(msg, 2, ""),
    after: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.orchestrator.scenario.v1.ReorderScenarioRequest}
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.ReorderScenarioRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.orchestrator.scenario.v1.ReorderScenarioRequest;
  return proto.witbooking.backoffice.orchestrator.scenario.v1.ReorderScenarioRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.orchestrator.scenario.v1.ReorderScenarioRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.orchestrator.scenario.v1.ReorderScenarioRequest}
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.ReorderScenarioRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPropertyTicker(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAfter(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.ReorderScenarioRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.orchestrator.scenario.v1.ReorderScenarioRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.orchestrator.scenario.v1.ReorderScenarioRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.ReorderScenarioRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPropertyTicker();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAfter();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string property_ticker = 1;
 * @return {string}
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.ReorderScenarioRequest.prototype.getPropertyTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.orchestrator.scenario.v1.ReorderScenarioRequest} returns this
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.ReorderScenarioRequest.prototype.setPropertyTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string id = 2;
 * @return {string}
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.ReorderScenarioRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.orchestrator.scenario.v1.ReorderScenarioRequest} returns this
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.ReorderScenarioRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string after = 3;
 * @return {string}
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.ReorderScenarioRequest.prototype.getAfter = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.orchestrator.scenario.v1.ReorderScenarioRequest} returns this
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.ReorderScenarioRequest.prototype.setAfter = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.ReorderScenarioResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.orchestrator.scenario.v1.ReorderScenarioResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.orchestrator.scenario.v1.ReorderScenarioResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.ReorderScenarioResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.orchestrator.scenario.v1.ReorderScenarioResponse}
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.ReorderScenarioResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.orchestrator.scenario.v1.ReorderScenarioResponse;
  return proto.witbooking.backoffice.orchestrator.scenario.v1.ReorderScenarioResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.orchestrator.scenario.v1.ReorderScenarioResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.orchestrator.scenario.v1.ReorderScenarioResponse}
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.ReorderScenarioResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.ReorderScenarioResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.orchestrator.scenario.v1.ReorderScenarioResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.orchestrator.scenario.v1.ReorderScenarioResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.ReorderScenarioResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.Scenario.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.orchestrator.scenario.v1.Scenario.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.orchestrator.scenario.v1.Scenario} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.Scenario.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    active: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    ticker: jspb.Message.getFieldWithDefault(msg, 3, ""),
    engineMultiConfigTicker: jspb.Message.getFieldWithDefault(msg, 5, ""),
    name: jspb.Message.getFieldWithDefault(msg, 6, ""),
    actionsMap: (f = msg.getActionsMap()) ? f.toObject(includeInstance, undefined) : [],
    criteria: (f = msg.getCriteria()) && witbooking_backoffice_orchestrator_common_v1_orchestration_criteria_pb.OrchestrationCriteria.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.orchestrator.scenario.v1.Scenario}
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.Scenario.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.orchestrator.scenario.v1.Scenario;
  return proto.witbooking.backoffice.orchestrator.scenario.v1.Scenario.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.orchestrator.scenario.v1.Scenario} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.orchestrator.scenario.v1.Scenario}
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.Scenario.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setActive(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTicker(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setEngineMultiConfigTicker(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 7:
      var value = msg.getActionsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    case 8:
      var value = new witbooking_backoffice_orchestrator_common_v1_orchestration_criteria_pb.OrchestrationCriteria;
      reader.readMessage(value,witbooking_backoffice_orchestrator_common_v1_orchestration_criteria_pb.OrchestrationCriteria.deserializeBinaryFromReader);
      msg.setCriteria(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.Scenario.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.orchestrator.scenario.v1.Scenario.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.orchestrator.scenario.v1.Scenario} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.Scenario.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getActive();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getTicker();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getEngineMultiConfigTicker();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getActionsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(7, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getCriteria();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      witbooking_backoffice_orchestrator_common_v1_orchestration_criteria_pb.OrchestrationCriteria.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.Scenario.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.orchestrator.scenario.v1.Scenario} returns this
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.Scenario.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool active = 2;
 * @return {boolean}
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.Scenario.prototype.getActive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.witbooking.backoffice.orchestrator.scenario.v1.Scenario} returns this
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.Scenario.prototype.setActive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional string ticker = 3;
 * @return {string}
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.Scenario.prototype.getTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.orchestrator.scenario.v1.Scenario} returns this
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.Scenario.prototype.setTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string engine_multi_config_ticker = 5;
 * @return {string}
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.Scenario.prototype.getEngineMultiConfigTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.orchestrator.scenario.v1.Scenario} returns this
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.Scenario.prototype.setEngineMultiConfigTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string name = 6;
 * @return {string}
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.Scenario.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.orchestrator.scenario.v1.Scenario} returns this
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.Scenario.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * map<string, string> actions = 7;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.Scenario.prototype.getActionsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 7, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.witbooking.backoffice.orchestrator.scenario.v1.Scenario} returns this
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.Scenario.prototype.clearActionsMap = function() {
  this.getActionsMap().clear();
  return this;};


/**
 * optional witbooking.backoffice.orchestrator.common.v1.OrchestrationCriteria criteria = 8;
 * @return {?proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCriteria}
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.Scenario.prototype.getCriteria = function() {
  return /** @type{?proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCriteria} */ (
    jspb.Message.getWrapperField(this, witbooking_backoffice_orchestrator_common_v1_orchestration_criteria_pb.OrchestrationCriteria, 8));
};


/**
 * @param {?proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCriteria|undefined} value
 * @return {!proto.witbooking.backoffice.orchestrator.scenario.v1.Scenario} returns this
*/
proto.witbooking.backoffice.orchestrator.scenario.v1.Scenario.prototype.setCriteria = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.orchestrator.scenario.v1.Scenario} returns this
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.Scenario.prototype.clearCriteria = function() {
  return this.setCriteria(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.Scenario.prototype.hasCriteria = function() {
  return jspb.Message.getField(this, 8) != null;
};


goog.object.extend(exports, proto.witbooking.backoffice.orchestrator.scenario.v1);
